@for (toast of toastService.toasts; track toast) {
<ngb-toast
  [class]="toast.className"
  [autohide]="true"
  [delay]="toast.delay || 3000"
  (hidden)="toastService.remove(toast)"
>
  @if (isTemplate(toast)) {
  <ng-template [ngTemplateOutlet]="toast.textOrTpl"></ng-template>
  } @else { @if (toastService.toastType == 1) {
  <mat-icon aria-hidden="false" aria-label="Example check-circle-outline icon">
    check_circle_outline</mat-icon
  >
  } @if (toastService.toastType == 2) {
  <mat-icon aria-hidden="false" aria-label="Example warning-amber icon">
    warning_amber</mat-icon
  >
  }
  {{ toastService.toastType == 1 ? "Success" : "Alert" }}:
  {{ toast.textOrTpl }}
  <span class="hoover-button" (click)="toastService.remove(toast)">X</span>
  }
</ngb-toast>
}
